import React from 'react';
import classNames from 'classnames';
import './breadCrumb.scss';

export type BreadCrumbProps = {
  label: string;
  isRoot?: boolean;
  color?: string;
};

export const BreadCrumb: React.FC<BreadCrumbProps> = ({
  label,
  color,
  isRoot,
}) => (
  <span
    className={classNames(
      'breadcrumb',
      color ? `breadcrumb--${color}` : undefined,
      isRoot ? `root root--${color}` : 'secondary'
    )}
  >
    {label}
  </span>
);
